<template>
	<div id="content-wrapper" class="d-flex flex-column">
        <div id="content">

            <sidebar />

            <div class="container-fluid">
                <transition mode="out-in" name="leftIn">
                    <router-view></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import sidebar    from "./sidebar.vue"
    import pageFooter from "./footer.vue"

    export default { 
        name: "template-content",
        components: { 
            sidebar, 
            pageFooter 
        } 
    }
</script>

<style scoped>
</style>
